export default __webpack_public_path__ + "static/media/(86).6f757026.jpg";